'use client';

import { createContext, ReactNode, useContext } from 'react';

export type Secrets = {
    amplitudeApiKey: string;
    apiRoot: string;
    atgpayEnv: string;
    baseUrl: string;
    buildNumber: string;
    classicUrl: string;
    isAiEnabled: boolean;
    passwordReset: string;
    toolboxUrl: string;
};

type Props = {
    children: ReactNode;
    value: Secrets;
};

export const defaultSecrets: Secrets = {
    amplitudeApiKey: '',
    apiRoot: '',
    atgpayEnv: '',
    baseUrl: '',
    buildNumber: '',
    classicUrl: '',
    isAiEnabled: false,
    passwordReset: '',
    toolboxUrl: '',
};

const SecretContext = createContext<Secrets>(defaultSecrets);

export const SecretsProvider = ({ children, value }: Props) => {
    return <SecretContext.Provider value={value}>{children}</SecretContext.Provider>;
};

export const useSecrets = () => useContext(SecretContext);
